export type BenefitHeroSlideId = Branded<string, 'benefitHeroSlideId'>;

export interface BenefitHeroSlide {
  id: BenefitHeroSlideId;
  heading: string;
  subheading: string;
  copy: string;
}

export interface BenefitHeroSlideDto {
  id: BenefitHeroSlideId;
  heading: string;
  subheading: string | null;
  copy: string | null;
}

export class BenefitHeroSlideModel {
  static fromDto = (dto: BenefitHeroSlideDto): BenefitHeroSlide => ({
    id: dto.id,
    heading: dto.heading ?? '',
    subheading: dto.subheading ?? '',
    copy: dto.copy ?? '',
  });
}
